var exports = {
  "kL": "xdbfd91f1--b14532--container",
  "oR": "xdbfd91f1--b14532--builder_badge",
  "eX": "xdbfd91f1--b14532--builder_name",
  "Sx": "xdbfd91f1--b14532--builder_image",
  "oK": "xdbfd91f1--b14532--default_builder",
  "OF": "xdbfd91f1--b14532--default_builder_img",
  "zV": "xdbfd91f1--b14532--description_container",
  "mG": "xdbfd91f1--b14532--inline",
  "lZ": "xdbfd91f1--b14532--phone",
  "Ke": "xdbfd91f1--b14532--phone_button_container",
  "IB": "xdbfd91f1--b14532--villages_count_container",
};

module.exports = exports;
